"use client";
import { styled } from "@mui/material/styles";
import { Text } from "@nxt-costco-com/forge-components";
import { FontLineHeightSm } from "@nxt-costco-com/forge-design-tokens";
const OrdersAndReturnsLinkText = styled(Text)(({ theme }) => ({
  width: "fit-content",
  [theme.breakpoints.down("md")]: {
    fontSize: ".625rem",
    lineHeight: FontLineHeightSm
  },
  [theme.breakpoints.up("md")]: {
    ...theme.typography.t6
  },
  [theme.breakpoints.up("lg")]: {
    ...theme.typography.t5
  }
}));
export {
  OrdersAndReturnsLinkText
};
